<template>
  <div>
    <div class="flex flex-col gap-2">
      <PromoSuggestionCard 
        v-for="suggestion in inAppPromos" 
        :key="suggestion.bundleId" 
        :suggestion-name="suggestion.name"
        :currency-symbol="currency.symbol"
        :show-up-to="suggestion.quantity ? true : false"
        :add-on-price="suggestion.addOnPrice"
        :show-add-on-original-price="!suggestion.quantity ? true : false"
        :add-on-original-price="suggestion.addOnTest ? suggestion.addOnTest.price : 0"
        :add-on-test-name="suggestion.addOnTest ? suggestion.addOnTest.testName : ''"
        :savings="suggestion.savings"
        :remaining-quantity="suggestion.remainingQuantity"
        @addTest="addTest(suggestion)"
        @hideSuggestion="$emit('hideSuggestion', suggestion)"
      />
    </div>
    <div v-if="isOpenXChooseYDialog">
      <BuildBundleDialog
        :is-show-dialog="isOpenXChooseYDialog"
        :title="suggestBundle.bundleName"
        :bundle-id="suggestBundle.bundleId"
        @close="isOpenXChooseYDialog = false"
        @cancel="isOpenXChooseYDialog = false"
        @add-to-cart="addBuildBundlePromo"
      />
    </div>
  </div>
</template>

<script>
import PromoSuggestionCard from "./PromoSuggestionCard.vue";
import BuildBundleDialog from "@/views/va-orderTest/order-page/promo-panel/build-bundle-dialog/index.vue";

import { mapState, mapGetters } from "vuex";
import { addBuildBundlePromoFromDialog } from "@/views/va-orderTest/order-page/promo-panel/index.js";

export default {
  components: {
    PromoSuggestionCard,
    BuildBundleDialog,
  },
  props: {
    inAppPromos: {
      type: Array,
      default: () => []
    },
  },
  emits: ['hideSuggestion'],
  data() {
    return {
      suggestBundle: null,
      isOpenXChooseYDialog: false
    }
  },
  computed: {
    ...mapState(['currency']),
    ...mapGetters('orderTest/panels', ['bundleList']),
    ...mapGetters('orderTest', ['orderTestSupportObj'])
  },
  methods: {
    addTest(suggestion) {
      if (suggestion.quantity) {
        // x choose y
        this.suggestBundle = this.bundleList.find(bundle => bundle.bundleId === suggestion.bundleId);
        if (this.suggestBundle) {
          this.isOpenXChooseYDialog = true;
        }
      } else {
        this.$store.dispatch("orderTest/addSelectedTest", { id: suggestion.addOnTest.id });
      }
    },

    addBuildBundlePromo(payload) {
      addBuildBundlePromoFromDialog(payload, this.orderTestSupportObj);
      this.isOpenXChooseYDialog = false;
    },
  }
}
</script>
